export default __webpack_public_path__ + "static/media/project5.9712164c.JPG";